import kbpgp from 'kbpgp'
import {promisify} from 'utils/promise.utils'
import createKeyManager from './createKeyManager'

export default async ({keyManager, keys, passphrase, msg}) => {
  const km = keyManager || (await createKeyManager(keys, passphrase))
  return promisify(kbpgp.box, kbpgp)({msg, encrypt_for: km})
}
